import { io } from "socket.io-client";
import { API_ROOT } from "./axios.config";

// Socket.IO is mounted on the API server itself, so it shares the API origin.
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || API_ROOT;

let socket = null;

const getSocket = () => {
  if (!socket) {
    socket = io(SOCKET_URL, {
      autoConnect: false,
      transports: ["websocket"],
    });
  }
  return socket;
};

export const connectSocket = () => {
  const token = localStorage.getItem("Token");
  if (!token) return;
  const s = getSocket();
  s.auth = { token };
  if (!s.connected) s.connect();
};

export const disconnectSocket = () => {
  if (socket?.connected) {
    socket.disconnect();
  }
};

export { getSocket };
